import React, {Fragment, useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'
import '../Overview.css'
import Modal from 'react-bootstrap/Modal'
import Forms from './Form'
import UserService from '../../../../../services/user'
import MasterService from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import Dropdown from 'react-bootstrap/Dropdown'
import {toast} from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import {useSearchParams} from 'react-router-dom'
import MasterServices from '../../../../../services/master'
import {PageTitle} from '_metronic/layout/core'

const Other = () => {
  const [searchParams] = useSearchParams()
  const [show, setShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [submit, setSubmit] = useState(false)
  const [data, setData] = useState<any>({})
  const [dataUser, loading, isError, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [profiencies, setProficiencies] = useState<any>([])
  const [skills, setSkills] = useState<any>([])

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  useEffect(() => {
    getMaster()
    getSkills()
    return () => {
    }
  }, [])

  const getMaster = async () => {
    try {
      await MasterService.getProficiency({is_active: 1}).then((res) => {
        setProficiencies(res.data?.data)
      })
    } catch (error) {}
  }

  const getSkills = async () => {
    try {
      await MasterService.getSkill({is_active: 1}).then((res) => {
        setSkills(res.data?.data)
      })
    } catch (error) {}
  }

  const toggle = () => {
    if (show) {
      setIsEdit(false)
      setFormValue({})
    }
    setShow(!show)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (!window.confirm('Yakin Ingin Menghapus Lainnya ?')) {
        return
      }
      setLoadingDelete(true)
      setSubmit(true)

      await UserService.deleteOther(id).then(() => {
        toast.success('Lainnya berhasil dihapus')
        triggerRefresh()
      })
    } catch (error) {
      toast.success('Lainnya gagal dihapus')
    } finally {
      setSubmit(false)
      setLoadingDelete(false)
    }
  }
  return (
    <div>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Form' : 'Form'} Lainnya</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {show && (
            <Forms
              onChange={onChange}
              editFormValue={formValue}
              toggle={toggle}
              getData={triggerRefresh}
              master={profiencies}
              skills={skills}
            />
          )}
        </Modal.Body>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              {localStorage.getItem('role') == 'Alumni' && (
                <PageTitle
                  breadcrumbs={[
                    {
                      title: 'Dashboard',
                      path: '/dashboard',
                      isSeparator: false,
                      isActive: false,
                    },
                    {
                      title: '/',
                      path: '',
                      isSeparator: false,
                      isActive: false,
                    },
                  ]}
                >
                  Lainnya
                </PageTitle>
              )}
              <h4>Lainnya</h4>
            </div>
            <div className='col-md-6'>
              {!searchParams.get('alumni') && (
                <Button
                  onClick={toggle}
                  className='btn btn-primary btn-sm btn-add'
                  style={{float: 'right'}}
                >
                  Tambah
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className='col-md-12 d-grid gap-10'>
          <div style={{textAlign: 'center'}}>
            {loading && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {!loading && data?.others?.length === 0 && <h3>Tidak ada data Lainnya</h3>}
          </div>

          <div className='d-grid gap-10'>
            {data?.others?.map((item: any, key: any) => {
              return (
                <Fragment key={Math.random()}>
                  <div className='card-custom'>
                    <div className='row'>
                      <div className='col-md-6 p-2'>
                        <h5>{item?.user_others_title}</h5>
                      </div>
                      <div className='col-md-6'>
                        {!searchParams.get('alumni') && (
                          <Dropdown>
                            <Dropdown.Toggle
                              id='dropdown-basic'
                              style={{float: 'right'}}
                              className='btn btn-primary btn-sm'
                            >
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href='#/action-1'
                                onClick={() => {
                                  setIsEdit(true)
                                  setFormValue({
                                    title: item?.user_others_title,
                                    description: item?.user_others_description,
                                    rowDetail: item,
                                  })
                                  toggle()
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                href='#/action-2'
                                onClick={() => {
                                  handleDelete(item?.user_others_id)
                                }}
                              >
                                Hapus
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </div>
                      <div className='col-md-12 p-2'>
                        <p>{item?.user_others_description || '-'}</p>
                      </div>
                      {item?.document_url_full ? (
                        <div className='col-md-12 p-2'>
                          <p>Dokumen Pendukung</p>
                          <a
                            href={item?.document_url_full}
                            target='_blank'
                            className='btn btn-primary btn-sm'
                            rel='noreferrer'
                          >
                            Sertifikat
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Other
